import {
  BaseEdge,
  EdgeLabelRenderer,
  getBezierPath,
  type EdgeProps,
} from "@xyflow/react";
import styles from "./ManualEdge.module.css";

interface ManualEdgeData {
  manual?: boolean;
  linkId?: string;
  onDelete?: (linkId: string) => void;
}

export default function ManualEdge(props: EdgeProps) {
  const {
    id,
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
    label,
    selected,
    markerEnd,
    style,
    data,
  } = props;

  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  const d = data as ManualEdgeData | undefined;

  return (
    <>
      <BaseEdge id={id} path={edgePath} markerEnd={markerEnd} style={style} />
      <EdgeLabelRenderer>
        <div
          className={`${styles.tools} ${selected ? styles.selected : ""}`}
          style={{
            transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`,
          }}
        >
          {label && <span className={styles.label}>{label}</span>}
          {d?.manual && d.linkId && d.onDelete && (
            <button
              type="button"
              className={styles.delete}
              aria-label="Delete link"
              title="Delete link"
              onClick={(e) => {
                e.stopPropagation();
                d.onDelete?.(d.linkId as string);
              }}
            >
              ×
            </button>
          )}
        </div>
      </EdgeLabelRenderer>
    </>
  );
}
